import { decodeJwt } from 'jose';

import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';

import { filter, Observable, of, race, switchMap, take } from 'rxjs';

import { Store } from '@ngrx/store';

import { userActions } from '../+state/user.actions';
import { selectUserState } from '../+state/user.selectors';
import { HESTIA_USER_MODULE_CONFIG, IHestiaUserModuleConfig } from '../constants';

@Injectable()
export class AuthNoneGuard {
  constructor(
    private store: Store,
    private router: Router,
    @Inject(HESTIA_USER_MODULE_CONFIG) private userConfig: IHestiaUserModuleConfig
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return race(
      this.store
        .select((state) => state[this.userConfig.syncHydratedKey])
        .pipe(
          filter((hydrated) => hydrated === true),
          switchMap(() => this.store.select(selectUserState)),
          take(1),
          switchMap((userState) => {
            if (!userState.jwt) {
              return of(true);
            }

            const decodedToken = decodeJwt(userState.jwt);

            if (decodedToken && Date.now() <= decodedToken?.exp! * 1000) {
              if (userState.kioskMode) {
                return of(this.router.parseUrl('ssn-entry'));
              } else {
                return of(this.router.parseUrl(this.userConfig.isUnauthenticatedGuardFailureRoute));
              }
            } else {
              this.store.dispatch(userActions.fullResetState());
              return of(true);
            }
          })
        )
    );
  }
}
